import { TFunction } from "react-i18next";
import {
	ItemApi,
	ItemOrderType,
	ModifierGroupApi,
	ModifierGroupOptionApi,
	QuantityInfoApi,
	QuantityInfoOverrideApi,
} from "../../../../../../../../../services/Api/Organization/types";

export const checkIfValueIsEmpty = (value?: string | number | null): boolean => {
	return value === "" || value === undefined || value === null;
};

export const getOrderTypes = (t: TFunction) => {
	const possibleOrderTypes = Object.values(ItemOrderType);
	return possibleOrderTypes.map((orderType) => ({
		id: orderType,
		label: t(`enums.orders.types.${orderType}`),
	}));
};

export const sortModifierGroupsByPositions = (data: ModifierGroupApi[], items: ItemApi[]) => {
	const newArr: ModifierGroupApi[] = [];
	const allItems = items
		.map((x) => x.modifier_groups)
		.flat()
		.sort((a, b) => a.position - b.position);
	allItems.forEach((item, index) => {
		item.position = index;
		const found = data.find((f) => f.id === item.modifier_group_id);
		if (found && !newArr[item.position]) {
			newArr[item.position] = found;
		}
	});
	return newArr.filter((item, index) => newArr.indexOf(item) === index);
};

export const getModifiersSumOfDefaultQuantity = (modifierGroups: QuantityInfoApi[]) => {
	return modifierGroups.reduce((sum, option) => {
		return sum + (Number(option.default_quantity) || 0);
	}, 0);
};

export const getDefaultQuantitiesOptions = (
	actualOptions: QuantityInfoOverrideApi[],
	defaultOptions: ModifierGroupOptionApi[]
): QuantityInfoApi[] => {
	return actualOptions
		.map((actualOption, index) => {
			if (typeof actualOption.quantity_info.default_quantity === "number") {
				return actualOption.quantity_info;
			}

			if (typeof defaultOptions[index].quantity_info?.default_quantity === "number") {
				return defaultOptions[index].quantity_info;
			}

			return null;
		})
		.filter((option) => option !== null);
};

export const getModifiersModalCorrectFormValueForValidation = (
	primaryValue?: string | null | number,
	secondaryValue?: string | null | number
) => (typeof primaryValue === "number" ? primaryValue : secondaryValue);
